import { fetchCart, postCart } from 'src/libs/api/cartApi';
import { type CartItem } from 'src/models/orderLimits/schema';
import { clearCartInCookie, getCartFromCookie } from './cookies';

export const combineCart = (aCart: CartItem[], bCart: CartItem[]) => {
  const combineMap = new Map<number, CartItem>();

  [...aCart, ...bCart].forEach((item) => {
    if (combineMap.has(item.productId)) {
      const existing = combineMap.get(item.productId);
      if (existing) {
        combineMap.set(item.productId, { productId: item.productId, quantity: item.quantity + existing.quantity });
      }
    } else {
      combineMap.set(item.productId, item);
    }
  });

  return Array.from(combineMap.values());
};

export const syncCart = async (currentShopId: number) => {
  const cartInCookie = getCartFromCookie();
  if (cartInCookie.length > 0) {
    const oldCartResponse = await fetchCart();
    if (oldCartResponse.isLeft()) {
      throw new Error(`get cart error before combine:${oldCartResponse.value.errors.join(',')}`);
    }
    const { cart } = oldCartResponse.value;
    const { products } = cart;
    const combined = combineCart(
      products.map((p) => ({ productId: p.productId, quantity: p.quantity })),
      cartInCookie
    );
    await postCart(currentShopId, combined);
    const newCartResponse = await fetchCart();
    if (newCartResponse.isLeft()) {
      throw new Error(`get cart error after combine:${newCartResponse.value.errors.join(',')}`);
    }
    clearCartInCookie();
    return newCartResponse.value;
  }
};
